import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { GlobalConstants } from "../common/global-constants";
import { BOItem } from "../models/BOItem.model";

@Injectable({
  providedIn: 'root'
}

)
export class IcdProxy{
    myAppUrl = GlobalConstants.apiURL;
    myApiUrlIcd11 = 'api/icd/';

  token='eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYmYiOjE3NjA0NTU3MDYsImV4cCI6MTc2MDQ1OTMwNiwiaXNzIjoiaHR0cHM6Ly9pY2RhY2Nlc3NtYW5hZ2VtZW50Lndoby5pbnQiLCJhdWQiOlsiaHR0cHM6Ly9pY2RhY2Nlc3NtYW5hZ2VtZW50Lndoby5pbnQvcmVzb3VyY2VzIiwiaWNkYXBpIl0sImNsaWVudF9pZCI6IjBjZGRjMDdkLTdkYmYtNDM0Mi1iNGNlLTkzYjE2MWVlODMwZV8wMmVjNmMzNi1mZDkwLTRmMDctOTk4NS01Zjc3OWJhNzI2NGYiLCJzY29wZSI6WyJpY2RhcGlfYWNjZXNzIl19.OYUbT1KHu3RM2Fnw-nitqsL3zCwHzBu1MPmsmjaHZVnG6yulg3aU6424vXiKgQNVNrsQkdFr78ZeuEbuKzqs9WO8jpxYQ4CKeboBvZ1x76BDBgK4sgiGQb2KwcdyQdtsuKyQ_McVdtJENTeyEqfBKscp_T19zDXz7XfjZwbe284hJHiDt9v38Xf3pCOWgQiihA8gaqsNnhjqrjcvkbVcZyCPW09sUyDDKOntGO6f0Z1c7JjrrLGMN2iXPBecen6Mj5_AMfKwf5r6QCSHPiCJDpIW8-NNT-lbwOUpvvl9qwEt77t3mMLrucANdHUlbrKmfKftLAlx1-fWGygwOLdP7w';
    constructor(private http:HttpClient){}

    // getIcd10(icd11Code:string):Observable<any>{

    //     return this.http.get<any>(this.myAppUrl + this.myApiUrlIcd11 + icd11Code);
    // }


        getIcd10(icd11Code:string):Observable<any>{
        const url=this.myAppUrl + this.myApiUrlIcd11 +'code/'+ icd11Code;
        const headers = new HttpHeaders({
            Authorization: `Bearer ${this.token}`, // tu token ya gestionado
            Accept: 'application/json',
            'X-API-KEY': 'e4b7c1c2-3d8a-44e7-babf-1a8f1d92af34'
          });
        return this.http.get(url, { headers });
    }

}
